import type { ApolloQueryResult } from '@apollo/client'
import type { CurrentUserOnboardingQuery } from '~/types/graphql-backend-types/gql-types'
import { gql } from '@apollo/client'
import { skipToken, useQuery } from '@tanstack/vue-query'

export function useCurrentUserOnboarding(isOnboardingDone: MaybeRefOrGetter<boolean>) {
  // Create a stable reference to the enabled state
  const queryFn = computed(() => toValue(isOnboardingDone) ? currentUserOnboarding : skipToken)

  return useQuery({
    queryKey: ['current-user-onboarding'],
    queryFn,
    select: (data) => {
      if (data.__typename === 'ProducerGraphql') {
        return data
      }
    },
  })
}

async function currentUserOnboarding() {
  const { query } = useGqlMikro()

  const { data, errors } = await query({
    query: GET_CURRENT_USER_ONBOARDING,
    variables: { },
  }) as ApolloQueryResult<CurrentUserOnboardingQuery>

  if (errors && errors.length > 0) {
    throw errors[0]
  }

  return data.me.client
}

const GET_CURRENT_USER_ONBOARDING = gql`
  query CurrentUserOnboarding($onboardingFilters: CompanyOnboardingInputGraphql) {
    me {
      client {
        ... on ProducerGraphql {
          onboardingDone
          onboardingNeeds
          onboarding(filters: $onboardingFilters) {
            done
            onboardingItems {
              done
              key
              value
            }
          }
        }
      }
    }
  }
`
